import React from 'react';
import { string, shape } from 'prop-types';

export default function CareerTile({ item, itemDirection, viewMoreText }) {
    return (
        <a
            href={item.url}
            className={`c-base-tile c-listing-tile ${itemDirection}`}
        >
            {item.thumbnail && (
                <div className="tile-image-wrapper">
                    <div className="tile-image">
                        <img src={item.thumbnail} alt="" />
                    </div>
                </div>
            )}
            <div className="tile-content">
                <div className="tile-title">
                    <h3>{item.title}</h3>
                    {item.subtext && <p className="subtext">{item.subtext}</p>}
                </div>

                <div className="tile-description">
                    {item.excerpt && <p>{item.excerpt}</p>}
                    <div className="btn-skin-3">{viewMoreText}</div>
                </div>
            </div>
        </a>
    );
}

CareerTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        thumbnail: string,
        title: string.isRequired,
        subtext: string,
        excerpt: string
    }).isRequired,
    itemDirection: string.isRequired,
    viewMoreText: string.isRequired
    /* eslint-enable react/no-typos */
};
